var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-table" },
    [
      _c(
        "a-tabs",
        [
          _c(
            "a-tab-pane",
            { key: "templates", attrs: { tab: _vm.$t("tables.templates") } },
            [
              _c(
                "div",
                { staticClass: "template-grid" },
                _vm._l(_vm.templates, function (template, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "template-card" },
                    [
                      _c(
                        "a-card",
                        { attrs: { title: template.name } },
                        [
                          _c("p", [_vm._v(_vm._s(template.description))]),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.createTableFromTemplate(
                                    template.id
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("tables.createTable")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            { key: "blank", attrs: { tab: _vm.$t("tables.blankTable") } },
            [
              _c(
                "a-form",
                { attrs: { model: _vm.table, layout: "vertical" } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("tables.tableName") } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.table.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.table, "name", $$v)
                          },
                          expression: "table.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    { attrs: { label: _vm.$t("tables.description") } },
                    [
                      _c("a-textarea", {
                        model: {
                          value: _vm.table.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.table, "description", $$v)
                          },
                          expression: "table.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.createTable },
                        },
                        [_vm._v(_vm._s(_vm.$t("tables.createTable")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }